export default __webpack_public_path__ + "static/media/dog-with girl.02f8183c.png";